import React from "react";
import { Link } from "react-router-dom";

type Props = {
  size?: "lg" | "sm";
  centered?: boolean;
  showTagline?: boolean;
  showSupportCopy?: boolean;
  to?: string;
  layout?: "stacked" | "inlineCompact";
};

export default function BrandLockup({
  size = "lg",
  centered = true,
  showTagline = true,
  showSupportCopy = false,
  to = "/",
  layout = "stacked",
}: Props) {
  const sizeClass = size === "lg" ? "text-6xl md:text-8xl" : "text-3xl md:text-4xl";
  const taglineSizeClass =
    size === "lg" ? "text-[11px] md:text-[36px]" : "text-[16px] md:text-[20px]";

  // ✅ Updated inlineCompact layout
  if (layout === "inlineCompact") {
    return (
      <div className={`flex ${centered ? "justify-center" : "justify-start"}`}>
        <Link to={to} className="inline-flex flex-col items-center leading-none">
          <span className="text-xl font-black tracking-tight sm:text-2xl">
            <span className="text-black dark:text-white">PayCalc</span>
            <span className="text-blue-600">Utility</span>
          </span>

          {showTagline ? (
            <span
              className="mt-0.5 text-[9px] font-black uppercase text-slate-400 dark:text-slate-500 sm:text-[10px]"
              style={{ letterSpacing: "0.35em" }}
            >
              CLARITY
            </span>
          ) : null}
        </Link>
      </div>
    );
  }

  // Default stacked layout (unchanged)
  return (
    <div className={`flex flex-col ${centered ? "items-center" : "items-start"}`}>
      <div className="flex flex-col items-center text-center">
        <Link to={to} className="inline-block">
          <h1 className={`${sizeClass} font-black tracking-tight leading-none whitespace-nowrap`}>
            <span className="text-black dark:text-white">PayCalc</span>
            <span className="text-blue-600">Utility</span>
          </h1>
        </Link>

        {showTagline && (
          <p
            className={`mt-1 ${taglineSizeClass} font-black uppercase text-slate-400 dark:text-slate-500 text-center`}
            style={{ letterSpacing: "0.6em" }}
          >
            CLARITY
          </p>
        )}
      </div>

      {showSupportCopy && (
        <p
          className={`mt-2 max-w-md text-xs text-slate-500 dark:text-slate-300 ${
            centered ? "text-center" : "text-left"
          }`}
        >
          High-integrity global payroll. Automated geofence timekeeping and statutory reporting.
        </p>
      )}
    </div>
  );
}